import type { FC } from "react"
import React, { createContext, useContext } from "react"

import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface GoodsReceiptContextValue {
  goodsReceipt: GoodsReceipt
  isResettingRef?: React.MutableRefObject<boolean>
  onAddPurchaseOrder?: () => void
  onRemovePurchaseOrder?: (purchaseOrderId: number) => void
  onEdit?: (goodsReceipt: GoodsReceipt) => void
  onDelete?: (goodsReceipt: GoodsReceipt) => void
  onUpload?: () => void
  onMarkAsNotReceived?: () => void
  onFinalizeCheckIn?: () => Promise<void>
  onCreatePallets?: () => void
}

interface GoodsReceiptProviderProps {
  value: GoodsReceiptContextValue
  children: React.ReactNode
}

const GoodsReceiptContext = createContext<GoodsReceiptContextValue | null>(null)

export const GoodsReceiptProvider: FC<GoodsReceiptProviderProps> = ({ value, children }) => (
  <GoodsReceiptContext.Provider value={value}>{children}</GoodsReceiptContext.Provider>
)

export const useGoodsReceiptContext = (): GoodsReceiptContextValue => {
  const context = useContext(GoodsReceiptContext)

  if (!context) {
    throw new Error("useGoodsReceiptContext must be used within a GoodsReceiptProvider")
  }

  return context
}
